import script from "./CardGestionTorneoMas.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardGestionTorneoMas.vue?vue&type=script&setup=true&lang=ts"

import "./CardGestionTorneoMas.vue?vue&type=style&index=0&id=2bb100be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb100be"]])

export default __exports__